"use client";
import { PersonalData } from "@/app/[locale]/dashboard/common/claim/personal-data";
import { Button } from "@/components/ui/button";
import { CredenzaBody, CredenzaFooter, CredenzaHeader, CredenzaTitle } from "@/components/ui/credenza";
import { LoadingButton } from "@/components/ui/loading-button";
import { useScopedI18n } from "@/locales/client";
import { trpc } from "@/util/trpc";

export function EditAddress({ goBack }: { goBack: () => void }) {
    const t = useScopedI18n("paymentDialogs.common.addressEdit");

    const updateUserData = trpc.lambda.users.updateUserData.useMutation({
        onSuccess: () => {
            goBack();
        },
    });

    return (
        <>
            <CredenzaHeader>
                <CredenzaTitle>{t("title")}</CredenzaTitle>
            </CredenzaHeader>
            <PersonalData
                splitInTwo={true}
                onSubmit={(values) => {
                    updateUserData.mutate(values);
                }}
                body={(children) => {
                    return <CredenzaBody>{children}</CredenzaBody>;
                }}
                footer={(children, readyToSave, readyToGoBack) => {
                    const items = [
                        readyToGoBack && (
                            <Button key="back" type="button" variant="outline" onClick={goBack}>
                                {t("buttons.goBack")}
                            </Button>
                        ),
                        readyToSave && (
                            <LoadingButton key="save" type="submit" loading={updateUserData.isPending}>
                                {t("buttons.save")}
                            </LoadingButton>
                        ),
                        children,
                    ].filter(Boolean);

                    const itemsReversed = readyToGoBack ? items : items.reverse();
                    return <CredenzaFooter className="mt-6">{itemsReversed}</CredenzaFooter>;
                }}
            />
        </>
    );
}
